import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import StudentDashboard from './student/StudentDashboard';
import GraderDashboard from './grader/GraderDashboard';

const CombinedDashboard = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('student');

  // Read tab from URL parameters
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabParam = searchParams.get('tab');
    if (tabParam === 'grader' || tabParam === 'student') {
      setActiveTab(tabParam);
    }
  }, [location.search]);

  // Handle tab switching with URL update
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    navigate(`/dashboard?tab=${tab}`);
  };

  // Check if user has grader permissions
  const hasGraderAccess = user && (
    user.role === 'grader' || 
    user.role === 'admin' || 
    user.role === 'super-admin' ||
    user.permissions?.includes('submissions:grade')
  );

  if (!user) {
    return (
      <div className="container">
        <div className="loading">
          <div className="spinner"></div>
          Loading dashboard...
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      {/* Dashboard Content */}
      {activeTab === 'student' && (
        <div>
          <StudentDashboard user={user} hasGraderAccess={hasGraderAccess} />
        </div>
      )}

      {activeTab === 'grader' && hasGraderAccess && (
        <div>
          <GraderDashboard user={user} hasGraderAccess={hasGraderAccess} />
        </div>
      )}
    </div>
  );
};

export default CombinedDashboard;
